/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import type { IChatCenterState } from '../../api/domain';

enum ChatApiActions {
    FETCH_CHAT_CENTER_STATE = 'chat.center.state.fetch',
    FETCH_CHAT_CENTER_STATE_SUCCESS = 'chat.center.state.fetch.success',
    FETCH_CHAT_CENTER_STATE_FAILURE = 'chat.center.state.fetch.failure',
}

export const fetchChatCenterState = createAction(ChatApiActions.FETCH_CHAT_CENTER_STATE);
export const fetchChatCenterStateSuccess = createAction<IChatCenterState>(ChatApiActions.FETCH_CHAT_CENTER_STATE_SUCCESS);
export const fetchChatCenterStateFailure = createAction(ChatApiActions.FETCH_CHAT_CENTER_STATE_FAILURE);
